import React, { useState, useEffect, useCallback } from 'react';
import { localToday } from '../../utils/dateUtils';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './educacao.css';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import File from '../../assets/icons/file.svg';
import SearchInternal from '../../components/SearchInternal/SearchInternal';
import Modal from '../../components/modal';
import PageHeader from '../../components/PageHeader';
import { useEducation } from '../../context/educationContext';
import { useUsers } from '../../context/usersContext';
import { useUnits } from '../../context/unitsContext';
import TooltipInfo from '../../components/TooltipInfo/';
import InternalDataSkeleton from '../../components/InternalDataSkeleton';
import useSubmitLock from '../../utils/useSubmitLock';
import BinaryFileLink from '../../components/BinaryFileLink';
import { BINARY_RESOURCES, hasBinaryField } from '../../utils/binaryFile';


// Inicializa os dados do formulário de Educação
const initializeFormData = (userInfo) => ({
  internal: '',
  date: localToday(),
  scholarity: '',
  effected: false,
  evolution: '',
  professional: userInfo?.id || '',
  // Campos da recepção educacional
  reception_id: '',
  studied_previous_prisons: false,
  want_continue_studies: false,
  location_last_school_year: '',
  made_encceja: false,
  want_take_certification_exams: false,
  made_enem: false,
  want_take_enem: false,
  taken_professional_training_course: false,
  want_participate_professional_training_course: false,
  participated_complementary_educational_activity: false,
  want_participate_complementary_educational_activity: false,
  special_educational_support: '',
  internal_considerations: '',
  synthesis: '',
  file: null,
});

const Education = () => {
  const location = useLocation();
  const { internalId } = location.state || {};
  const { userInfo, effectiveUnitId, userUnits, requireWriteUnit } = useUsers();
  const { listBooks } = useUnits();
  const unitAcronym = Array.isArray(userUnits)
    ? userUnits.find((unit) => String(unit?.id) === String(effectiveUnitId))?.acronym
    : undefined;
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();
  const {
    createReceptioneducational,
    listReceptioneducational,
    updateReceptioneducational,
    updateInternalEducation,
    listInternalEducation,
    createInternalEducation,
    listEducationEvolution,
    createEducationEvolution,
    listScholarities,
    listReading,
    createReading,
    listEnrollments,
    createEnrollment,
    updateEnrollment,
    listClasses,
    listSubjects,
    listTeachers,
    listScores,
    createScore,
    updateScore,
    listFrequencies,
    createFrequency,
    updateFrequency,
    listFinalResults,
    createFinalResult,
    updateFinalResult,
    listLiteracyIbraema,
    createLiteracyIbraema,
    updateLiteracyIbraema,
    listCourses
  } = useEducation();


  // --- Dados básicos do interno ---
  const [internalDetails, setInternalDetails] = useState(null);
  const [currentTab, setCurrentTab] = useState('dados');
  const [formData, setFormData] = useState(() => initializeFormData(userInfo));
  // id da recepção educacional que já tem arquivo (o arquivo sai pela rota binary)
  const [receptionFileId, setReceptionFileId] = useState(null);

  // --- Formulários separados ---
  const [evolutions, setEvolutions] = useState([]);
  const [scholarities, setScholarities] = useState([]);
  const [readingFormData, setReadingFormData] = useState({
    id: '',
    date: localToday(),
    detail: '',
    resume: '',
    validated: false,
    observation: '',
    remission: false,
    book: '',
    internal: '',
  });
  const [enrollmentFormData, setEnrollmentFormData] = useState({
    class_education: '',
    start: localToday(),
    internal: ''
  });
  const [scoreFormData, setScoreFormData] = useState({
    date: localToday(),
    type_test: '',
    student: '',
    subject: '',
    score: '',
  });
  const [frequencyFormData, setFrequencyFormData] = useState({
    id: '',
    date: localToday(),
    presence: '',
    faults: '',
    student: '',
    subject: ''
  });
  const [finalFormData, setFinalFormData] = useState({
    id: '',
    date: localToday(),
    approved: '',
    observation: '',
    student: '',
    subject: ''
  });
  const [ibraemaFormData, setIbraemaFormData] = useState({
    id: '',
    start: localToday(),
    end: '',
    workload: '',
    workload_hours: '',
    workload_minutes: '',
    course: '',
    student: '',
    monitor: '',
    monitor_name: '',
    unit: effectiveUnitId || ''
  });

  // --- Modais ---
  const [isEnrollmentModalOpen, setIsEnrollmentModalOpen] = useState(false);
  const [isEditEnrollmentModalOpen, setIsEditEnrollmentModalOpen] = useState(false);
  const [editEnrollmentData, setEditEnrollmentData] = useState(null);
  const [isScoreModalOpen, setIsScoreModalOpen] = useState(false);
  const [isFrequencyModalOpen, setIsFrequencyModalOpen] = useState(false);
  const [isFinalModalOpen, setIsFinalModalOpen] = useState(false);
  const [isReadingModalOpen, setIsReadingModalOpen] = useState(false);
  const [isIbraemaModalOpen, setIsIbraemaModalOpen] = useState(false);

  // --- Listagens ---
  const [scores, setScores] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [classes, setClasses] = useState([]);
  const [courses, setCourses] = useState([]);
  const [enrollments, setEnrollments] = useState([]);
  const [frequencies, setFrequencies] = useState([]);
  const [finalResults, setFinalResults] = useState([]);
  const [freeReadings, setFreeReadings] = useState([]);
  const [literacies, setLiteracies] = useState([]);
  const [books, setBooks] = useState([]);
  const [bookQuery, setBookQuery] = useState('');
  const [bookResults, setBookResults] = useState([]);
  const [isSearchingBooks, setIsSearchingBooks] = useState(false);
  const [showBookResults, setShowBookResults] = useState(false);
  const [isSelectingInternal, setIsSelectingInternal] = useState(false);


  // Escolaridades
  useEffect(() => {
    const fetchScholarities = async () => {
      try {
        const response = await listScholarities();
        setScholarities(response?.results || []);
      } catch (error) {
        console.error("Erro ao buscar escolaridades:", error);
      }
    };
    fetchScholarities();
  }, [listScholarities]);

  // Livros — só "unit_acronym" filtra livros por unidade corretamente na API
  useEffect(() => {
    if (!unitAcronym) {
      setBooks([]);
      return;
    }

    const fetchBooks = async () => {
      try {
        let allBooks = [];
        let offset = 0;
        const limit = 100;
        let count = 0;
        do {
          const response = await listBooks({ limit, offset, unitAcronym });
          const results = response?.results || [];
          allBooks = [...allBooks, ...results];
          count = response?.count || 0;
          offset += limit;
        } while (offset < count);
        setBooks(allBooks);
      } catch (error) {
        console.error('Erro ao buscar livros:', error);
      }
    };
    fetchBooks();
  }, [listBooks, unitAcronym]);

  // Busca dinâmica de livro por título (Leitura Livre)
  useEffect(() => {
    const query = bookQuery.trim();

    if (query.length === 0) {
      setBookResults(books);
      setIsSearchingBooks(false);
      return;
    }

    if (!unitAcronym) {
      setBookResults([]);
      setIsSearchingBooks(false);
      return;
    }

    setIsSearchingBooks(true);
    const timer = setTimeout(async () => {
      try {
        const response = await listBooks({ limit: 20, title: query, unitAcronym });
        setBookResults(response?.results || []);
      } catch (error) {
        console.error('Erro ao buscar livros por título:', error);
        setBookResults([]);
      } finally {
        setIsSearchingBooks(false);
      }
    }, 350);

    return () => clearTimeout(timer);
  }, [bookQuery, books, listBooks, unitAcronym]);

  // Disciplinas e Professores
  useEffect(() => {
    const fetchSubjectsAndTeachers = async () => {
      try {
        const [subjectRes] = await Promise.all([
          listSubjects(),
          listTeachers(),
        ]);
        setSubjects(subjectRes?.results || []);
      } catch (error) {
        console.error("Erro ao buscar disciplinas ou professores:", error);
      }
    };
    fetchSubjectsAndTeachers();
  }, [listSubjects, listTeachers]);

  // --- Leitura Livre ---
  const loadFreeReadings = useCallback(async (internalId) => {
    try {
      const response = await listReading({ internal: internalId, start_date: '2025-01-01' });
      setFreeReadings(response?.results || []);
    } catch (error) {
      console.error('Erro ao buscar leituras livres:', error);
    }
  }, [listReading]);

  // Leituras
  useEffect(() => {
    if (formData.internal) {
      loadFreeReadings(formData.internal);
    }
  }, [formData.internal, loadFreeReadings]);

  // Frequências
  useEffect(() => {
    const fetchFrequencies = async () => {
      if (!formData.internal) return;
      try {
        const res = await listFrequencies({ internal: formData.internal, start_date: '2025-01-01' });
        setFrequencies(res?.results || []);
      } catch (error) {
        console.error("Erro ao buscar frequências:", error);
      }
    };
    fetchFrequencies();
  }, [formData.internal, listFrequencies]);

  // Notas
  useEffect(() => {
    const fetchScores = async () => {
      if (!formData.internal) return;
      const res = await listScores({ internal: formData.internal, start_date: '2025-01-01' });
      setScores(res?.results || []);
    };
    fetchScores();
  }, [formData.internal, listScores]);

  // Resultados Finais
  useEffect(() => {
    if (!formData.internal) return;
    listFinalResults({ internal: formData.internal, start_date: '2025-01-01' })
      .then(data => {
        setFinalResults(data?.results || []);
      })
      .catch(error => {
        console.error("Erro ao buscar resultados finais:", error);
        setFinalResults([]);
      });
  }, [formData.internal, listFinalResults]);


  // --- IBRAEMA ---
  const loadIbraemas = React.useCallback(async () => {
    if (!formData.internal) return;
    try {
      const res = await listLiteracyIbraema({ internal: formData.internal, start_date: '2025-01-01' });
      setLiteracies(res.results || []);
    } catch (error) {
      console.error('Erro ao carregar dados de alfabetização:', error);
    }
  }, [formData.internal, listLiteracyIbraema]);

  // Alfabetização Ibraema
  useEffect(() => {
    if (formData.internal) {
      loadIbraemas();
    }
  }, [formData.internal, loadIbraemas]);

  // Cursos
  useEffect(() => {
    listCourses()
      .then(res => setCourses(res.results || []))
      .catch(console.error);
  }, [listCourses]);

  // --- Seleção e carregamento do interno ---
  const handleInternalSelect = useCallback(
    async (internal) => {
      try {
        if (!internal?.id) {
          toast.error('Erro: interno inválido.');
          return;
        }
        //Buscando dados educacionais do interno
        const educationResponse = await listInternalEducation({ internal: internal.id, start_date: '2025-01-01' });
        const educationData = educationResponse?.results?.[0] || initializeFormData(userInfo);
        //Buscar recepção educacional (dados iniciais)
        const receptionResponse = await listReceptioneducational({ internal: internal.id, start_date: '2025-01-01' });
        const receptionData = receptionResponse?.results?.[0] || {};
        setReceptionFileId(hasBinaryField(receptionData, 'file') ? receptionData.id : null);
        // matriculas
        const enrollmentResponse = await listEnrollments({
          internal: internal.id,
          start_date: '2025-01-01'
        });
        setEnrollments(enrollmentResponse?.results || []);
        // classes
        const classesResponse = await listClasses({
          start_date: '2025-01-01',
        });
        setClasses(classesResponse?.results || []);
        setFormData({
          ...educationData,
          internal: internal.id,
          id: educationData?.id || '',
          reception_id: receptionData?.id || '',
          date: receptionData?.date || localToday(),
          studied_previous_prisons: receptionData?.studied_previous_prisons || false,
          want_continue_studies: receptionData?.want_continue_studies || false,
          location_last_school_year: receptionData?.location_last_school_year || '',
          made_encceja: receptionData?.made_encceja || false,
          want_take_certification_exams: receptionData?.want_take_certification_exams || false,
          made_enem: receptionData?.made_enem || false,
          want_take_enem: receptionData?.want_take_enem || false,
          taken_professional_training_course: receptionData?.taken_professional_training_course || false,
          want_participate_professional_training_course: receptionData?.want_participate_professional_training_course || false,
          participated_complementary_educational_activity: receptionData?.participated_complementary_educational_activity || false,
          want_participate_complementary_educational_activity: receptionData?.want_participate_complementary_educational_activity || false,
          special_educational_support: receptionData?.special_educational_support || '',
          internal_considerations: receptionData?.internal_considerations || '',
          synthesis: receptionData?.synthesis || '',
          file: receptionData?.file || null,
        });
        setInternalDetails(internal);
        setScores([]);
        setFinalResults([]);
        setLiteracies([]);
        setFrequencies([]);
        setFreeReadings([]);
        setEvolutions([]);
        //Buscando evoluções educacionais do interno
        const evolutionResponse = await listEducationEvolution({ internal: internal.id, start_date: '2025-01-01' });
        setEvolutions(evolutionResponse?.results || []);
      } catch (error) {
        console.error('Erro ao carregar dados do interno:', error);
        toast.error('Erro ao carregar dados do interno.');
      }
    },
    [listInternalEducation, listEducationEvolution, listReceptioneducational, listClasses, listEnrollments, userInfo]
  );

  // Carregar interno inicialmente se vier pelo location.state
  useEffect(() => {
    if (internalId) {
      const fetchInternal = async () => {
        try {
          const response = await listInternalEducation({ internal: internalId, start_date: '2025-01-01' });
          const internalData = response?.results?.[0];
          if (internalData) {
            handleInternalSelect(internalData);
          }
        } catch (error) {
          console.error("Erro ao carregar interno:", error);
        }
      };
      fetchInternal();
    }
  }, [internalId, listInternalEducation, handleInternalSelect]);


  // --- Formulário de Dados Gerais ---
  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value === "true", // Converte string para booleano
    }));
  };
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };
  const handleSubmitEducation = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      if (!formData.internal) {
        toast.error('Nenhum interno selecionado.');
        return;
      }
      try {
        // Atualiza ou cria os dados de escolaridade
        if (formData.id) {
          await updateInternalEducation(formData.id, formData);
        } else {
          await createInternalEducation(formData);
        }
        // Atualiza ou cria os dados de recepção educacional
        const receptionData = { ...formData };
        delete receptionData.file;
        let createdReception = null;
        if (formData.reception_id) {
          await updateReceptioneducational(formData.reception_id, receptionData);
        } else {
          createdReception = await createReceptioneducational(receptionData);
          setFormData((prev) => ({ ...prev, reception_id: createdReception.id }));
        }
        // Se houver um novo arquivo, fazer upload separadamente
        if (
          formData.file &&
          formData.file.constructor &&
          formData.file.constructor.name === 'File'
        ) {
          const fileData = new FormData();
          fileData.append('file', formData.file);
          fileData.append('internal', formData.internal);
          fileData.append('professional', userInfo.id);
          // NÃO definir Content-Type aqui; axios fará isso automaticamente ao enviar FormData
          const uploadedReception = await updateReceptioneducational(
            formData.reception_id || (createdReception ? createdReception.id : ''),
            fileData
          );
          if (hasBinaryField(uploadedReception, 'file')) setReceptionFileId(uploadedReception.id);
        }
      } catch (error) {
        console.error('Erro ao salvar ou atualizar dados educacionais:', error);
        toast.error('Erro ao processar dados educacionais.');
      }
    });
  };

  const handleReadingInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setReadingFormData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox" ? checked :
          value === "true" ? true :
            value === "false" ? false :
              value,
    }));
  };

  const handleSelectBook = (book) => {
    setReadingFormData((prev) => ({ ...prev, book: book.id }));
    setBookQuery(book.title);
    setShowBookResults(false);
  };
  const handleSubmitReading = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      try {
        if (!internalDetails?.id) {
          toast.error("Nenhum interno selecionado.");
          return;
        }
        const formData = new FormData();
        formData.append("date", readingFormData.date);
        formData.append("detail", readingFormData.detail);
        formData.append("observation", readingFormData.observation);
        formData.append("book", readingFormData.book);
        formData.append("internal", internalDetails.id);
        // Se houver arquivo, adiciona e define `validated` e `remission` como `True`
        if (readingFormData.resume) {
          formData.append("resume", readingFormData.resume);
          formData.append("validated", "True");
          formData.append("remission", "True");
        }
        await createReading(formData);
        // Reseta o formulário
        setReadingFormData({
          id: '',
          date: localToday(),
          detail: '',
          resume: null,
          validated: false,
          observation: '',
          remission: false,
          book: '',
          internal: internalDetails.id,
        });
        setBookQuery('');
        setShowBookResults(false);
        await loadFreeReadings(internalDetails.id);
        setIsReadingModalOpen(false);
      } catch (error) {
        console.error('Erro ao salvar leitura:', error);
      }
    });
  };

  // --- Evolução ---
  const handleSubmitEvolution = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      try {
        await createEducationEvolution({
          date: new Date().toISOString(),
          internal: formData.internal,
          professional: userInfo.id,
          data: formData.evolution,
        });
        const updatedEvolutions = await listEducationEvolution({ internal: formData.internal, start_date: '2025-01-01' });
        setEvolutions(updatedEvolutions?.results || []);
        setFormData((prev) => ({ ...prev, evolution: '' }));
      } catch (error) {
        console.error('Erro ao adicionar evolução educacional:', error);
      }
    });
  };

  // --- Matrícula ---
  const handleEnrollmentInputChange = (e) => {
    const { name, value } = e.target;
    setEnrollmentFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmitEnrollment = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      if (!formData.internal) {
        toast.error("Nenhum interno selecionado.");
        return;
      }
      try {
        const newEnrollment = {
          ...enrollmentFormData,
          class_education: Number(enrollmentFormData.class_education),
          internal: formData.internal
        };
        await createEnrollment(newEnrollment);
        const response = await listEnrollments({
          internal: formData.internal,
          start_date: '2025-01-01'
        });
        setEnrollments(response?.results || []);
        setEnrollmentFormData({
          class_education: '',
          start: localToday(),
          internal: formData.internal
        });
        setIsEnrollmentModalOpen(false);
      } catch (error) {
        console.error("Erro ao salvar matrícula:", error);
      }
    });
  };
  const prepareEditEnrollmentData = (enroll) => ({
    id: enroll.id,
    start: enroll.start?.split('T')[0] || '',
    end: enroll.end ? enroll.end.split('T')[0] : '',
    class_education: enroll.class_education,
  });
  const handleSubmitEditEnrollment = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      try {
        const payload = {
          class_education: Number(editEnrollmentData.class_education),
          start: editEnrollmentData.start,
          end: editEnrollmentData.end || null,
        };
        await updateEnrollment(editEnrollmentData.id, payload);
        const response = await listEnrollments({
          internal: formData.internal,
          start_date: '2025-01-01',
        });
        setEnrollments(response?.results || []);
        setIsEditEnrollmentModalOpen(false);
        setEditEnrollmentData(null);
      } catch (error) {
        console.error('Erro ao editar matrícula:', error);
      }
    });
  };

  // --- Notas ---
  const handleScoreInputChange = (e) => {
    const { name, value } = e.target;
    setScoreFormData(prev => ({
      ...prev,
      [name]: name === 'value' ? value : value
    }));
  };
  const handleSubmitScore = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      const payload = {
        date: scoreFormData.date,
        type_test: scoreFormData.type_test,
        student: Number(scoreFormData.student),
        subject: Number(scoreFormData.subject),
        score: parseFloat(scoreFormData.score),
      };
      try {
        if (scoreFormData.id) {
          await updateScore(scoreFormData.id, payload);
        } else {
          await createScore(payload);
        }
        const updated = await listScores({ internal: formData.internal, start_date: '2025-01-01' });
        setScores(updated?.results || []);
        setIsScoreModalOpen(false);
        setScoreFormData({
          date: localToday(),
          type_test: '',
          student: '',
          subject: '',
          score: '',
        });
      } catch (err) {
        console.error("Erro ao registrar nota:", err);
      }
    });
  };

  // --- Frequência ---
  const prepareFrequencyFormData = (freq) => ({
    id: freq.id,
    date: freq.date?.split('T')[0] || '',
    presence: freq.presence,
    faults: freq.faults,
    student: freq.student,
    subject: freq.subject
  });
  const handleSubmitFrequency = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      try {
        const payload = {
          date: frequencyFormData.date,
          presence: parseInt(frequencyFormData.presence, 10),
          student: Number(frequencyFormData.student),
          subject: Number(frequencyFormData.subject),
        };
        if (
          frequencyFormData.faults !== '' &&
          frequencyFormData.faults !== null &&
          frequencyFormData.faults !== undefined
        ) {
          payload.faults = parseInt(frequencyFormData.faults, 10);
        }
        if (frequencyFormData.id) {
          await updateFrequency(frequencyFormData.id, payload);
        } else {
          await createFrequency(payload);
        }
        const res = await listFrequencies({ internal: formData.internal, start_date: '2025-01-01' });
        setFrequencies(res?.results || []);
        setIsFrequencyModalOpen(false);
      } catch (err) {
        console.error("Erro ao registrar frequência:", err);
      }
    });
  };

  // --- Resultado Final ---
  const prepareFinalFormData = (fr) => ({
    id: fr.id,
    date: fr.date?.split('T')[0] || '',
    approved: fr.approved,
    observation: fr.observation,
    student: fr.student,
    subject: fr.subject
  });
  const openFinalModal = (result = null) => {
    if (result) {
      setFinalFormData({
        id: result.id,
        date: result.date.split('T')[0],
        approved: result.approved,
        observation: result.observation,
        student: result.student,
        subject: result.subject
      });
    } else {
      setFinalFormData(f => ({ ...f, id: '', approved: '', observation: '' }));
    }
    setIsFinalModalOpen(true);
  };
  const handleFinalChange = e => {
    const { name, value } = e.target;
    setFinalFormData(f => ({ ...f, [name]: value }));
  };
  const handleSubmitFinal = async e => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      try {
        const payload = {
          date: finalFormData.date,
          approved: finalFormData.approved,
          observation: finalFormData.observation,
          student: Number(finalFormData.student),
          subject: Number(finalFormData.subject),
        };
        if (finalFormData.id) {
          await updateFinalResult(finalFormData.id, payload);
        } else {
          await createFinalResult(payload);
        }
        setIsFinalModalOpen(false);
        const updated = await listFinalResults({ internal: formData.internal, start_date: '2025-01-01' });
        setFinalResults(updated.results || []);
      } catch (error) {
        console.error("Erro ao salvar resultado final:", error);
      }
    });
  };

  // --- IBRAEMA ---
  const prepareIbraemaFormData = (item) => ({
    id: item.id,
    start: item.start?.split('T')[0] || '',
    end: item.end?.split('T')[0] || '',
    workload: item.workload,
    workload_hours: item.workload ? item.workload.split(':')[0] : '',
    workload_minutes: item.workload ? item.workload.split(':')[1] : '',
    course: item.course,
    course_name: item.course_name,
    student: item.student,
    monitor: item.monitor || '',
    monitor_name: item.monitor_name,
    unit: item.unit || ''
  });

  const handleIbraemaChange = e => {
    const { name, value } = e.target;
    setIbraemaFormData(prev => ({
      ...prev,
      [name]: ['course', 'student', 'monitor'].includes(name) ? Number(value) : value
    }));
  };

  const handleSubmitIbraema = async e => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      const writeUnit = requireWriteUnit();
      if (!writeUnit.ok) {
        toast.warning(writeUnit.message);
        return;
      }
      // Validação de campos obrigatórios
      if (!ibraemaFormData.start) {
        toast.warning('Por favor, preencha a data de início.');
        return;
      }
      if (!ibraemaFormData.workload_hours && !ibraemaFormData.workload_minutes) {
        toast.warning('Por favor, preencha a carga horária.');
        return;
      }
      if (!ibraemaFormData.course) {
        toast.warning('Por favor, selecione o curso.');
        return;
      }
      if (!ibraemaFormData.student) {
        toast.warning('Por favor, selecione a matrícula.');
        return;
      }
      if (!ibraemaFormData.monitor) {
        toast.warning('Por favor, selecione o monitor.');
        return;
      }

      // Formatar workload a partir de workload_hours e workload_minutes
      const hours = ibraemaFormData.workload_hours || 0;
      const minutes = ibraemaFormData.workload_minutes || 0;
      const formattedWorkload = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:00`;
      // Monta o payload, ajustando o campo unit para garantir que seja um ID válido
      const payload = {
        start: ibraemaFormData.start,
        workload: formattedWorkload,
        course: Number(ibraemaFormData.course),
        student: Number(ibraemaFormData.student),
        monitor: ibraemaFormData.monitor, // Mantém como string
        unit: writeUnit.unitId,
      };
      // Só inclui o campo end se estiver preenchido
      if (ibraemaFormData.end) {
        payload.end = ibraemaFormData.end;
      }
      if (ibraemaFormData.id) {
        await updateLiteracyIbraema(ibraemaFormData.id, payload);
      } else {
        await createLiteracyIbraema(payload);
      }
      setIsIbraemaModalOpen(false);
      // Resetar formulário de Ibraema
      setIbraemaFormData({
        id: '',
        start: localToday(),
        end: '',
        workload: '',
        workload_hours: '',
        workload_minutes: '',
        course: '',
        student: '',
        monitor: '',
        monitor_name: '',
        unit: effectiveUnitId || ''
      });
      await loadIbraemas();
    });
  };


  // Modal close/reset handlers
  const closeEditEnrollmentModal = () => {
    setIsEditEnrollmentModalOpen(false);
    setEditEnrollmentData(null);
  };
  const closeFrequencyModal = () => {
    setIsFrequencyModalOpen(false);
    setFrequencyFormData({
      id: '',
      date: localToday(),
      presence: '',
      faults: '',
      student: '',
      subject: ''
    });
  };
  const closeFinalResultModal = () => {
    setIsFinalModalOpen(false);
    setFinalFormData({
      id: '',
      date: localToday(),
      approved: '',
      observation: '',
      student: '',
      subject: ''
    });
  };
  const closeIbraemaModal = () => {
    setIsIbraemaModalOpen(false);
    setIbraemaFormData({
      id: '',
      start: localToday(),
      end: '',
      workload: '',
      workload_hours: '',
      workload_minutes: '',
      course: '',
      student: '',
      monitor: '',
      monitor_name: '',
      unit: effectiveUnitId || ''
    });
  };

  return (
    <div>
      <Sidebar />
      <Header />
      <div className="container social-container admission-page">
        <Titulo>
          <SearchInternal
            onSelect={handleInternalSelect}
            onSelectingChange={setIsSelectingInternal}
          />
        </Titulo>

        <PageHeader
          title="Educação"
          subtitle="Atendimento e evolução educacional do interno."
          internalDetails={internalDetails}
        />

        {isSelectingInternal ? (
          <InternalDataSkeleton blocks={4} />
        ) : (
          <>
        <div className="social-tabs">
          <button className={`social-tab-button ${currentTab === 'dados' ? 'active' : ''}`} onClick={() => setCurrentTab('dados')}>Acolhimento</button>
          <button className={`social-tab-button ${currentTab === 'matricula' ? 'active' : ''}`} onClick={() => setCurrentTab('matricula')}>Matrícula</button>
          <button className={`social-tab-button ${currentTab === 'notas' ? 'active' : ''}`} onClick={() => setCurrentTab('notas')}>Boletim</button>
          <button className={`social-tab-button ${currentTab === 'frequencia' ? 'active' : ''}`} onClick={() => setCurrentTab('frequencia')}>Frequência</button>
          <button className={`social-tab-button ${currentTab === 'resultado' ? 'active' : ''}`} onClick={() => setCurrentTab('resultado')}>Resultado Final</button>
          <button className={`social-tab-button ${currentTab === 'alfabetizacao' ? 'active' : ''}`} onClick={() => setCurrentTab('alfabetizacao')}>IBRAEMA</button>
          <button className={`social-tab-button ${currentTab === 'leitura' ? 'active' : ''}`} onClick={() => setCurrentTab('leitura')}>Leitura Livre</button>
          <button className={`social-tab-button ${currentTab === 'evolucao' ? 'active' : ''}`} onClick={() => setCurrentTab('evolucao')}>Evolução</button>
        </div>

        <div className="social-tab-content">
          {currentTab === 'dados' && (
            <form onSubmit={handleSubmitEducation}>

              <div className='form-group'>
                <label>Escolaridade</label>
                <select name="scholarity" value={formData.scholarity || ''} onChange={handleInputChange} required>
                  <option value="">Selecione</option>
                  {scholarities.map((scholarity) => (
                    <option key={scholarity.id} value={scholarity.id}>
                      {scholarity.nivel}
                    </option>
                  ))}
                </select>
              </div>



              <div className='form-group'>
                <label>Estudou em presídios anteriores</label>
                <select name="studied_previous_prisons" value={formData.studied_previous_prisons ? "true" : "false"} onChange={handleSelectChange}>
                  <option value="false">Não</option>
                  <option value="true">Sim</option>
                </select>
              </div>

              <div className='form-group'>
                <label>Deseja continuar os estudos</label>
                <select name="want_continue_studies" value={formData.want_continue_studies ? "true" : "false"} onChange={handleSelectChange}>
                  <option value="false">Não</option>
                  <option value="true">Sim</option>
                </select>
              </div>

              <div className='form-group'>
                <label>Realizou o ENCCEJA</label>
                <select name="made_encceja" value={formData.made_encceja ? "true" : "false"} onChange={handleSelectChange}>
                  <option value="false">Não</option>
                  <option value="true">Sim</option>
                </select>
              </div>

              <div className='form-group'>
                <label>Quer participar de exames de certificação</label>
                <select name="want_take_certification_exams" value={formData.want_take_certification_exams ? "true" : "false"} onChange={handleSelectChange}>
                  <option value="false">Não</option>
                  <option value="true">Sim</option>
                </select>
              </div>

              <div className='form-group'>
                <label>Realizou o ENEM</label>
                <select name="made_enem" value={formData.made_enem ? "true" : "false"} onChange={handleSelectChange}>
                  <option value="false">Não</option>
                  <option value="true">Sim</option>
                </select>
              </div>

              <div className='form-group'>
                <label>Quer participar do ENEM</label>
                <select name="want_take_enem" value={formData.want_take_enem ? "true" : "false"} onChange={handleSelectChange}>
                  <option value="false">Não</option>
                  <option value="true">Sim</option>
                </select>
              </div>

              <div className='form-group'>
                <label>Realizou curso profissionalizante</label>
                <select name="taken_professional_training_course" value={formData.taken_professional_training_course ? "true" : "false"} onChange={handleSelectChange}>
                  <option value="false">Não</option>
                  <option value="true">Sim</option>
                </select>
              </div>

              <div className='form-group'>
                <label>Quer participar de curso profissionalizante</label>
                <select name="want_participate_professional_training_course" value={formData.want_participate_professional_training_course ? "true" : "false"} onChange={handleSelectChange}>
                  <option value="false">Não</option>
                  <option value="true">Sim</option>
                </select>
              </div>

              <div className='form-group'>
                <label>Realizou atividade socioeducativa</label>
                <select name="participated_complementary_educational_activity" value={formData.participated_complementary_educational_activity ? "true" : "false"} onChange={handleSelectChange}>
                  <option value="false">Não</option>
                  <option value="true">Sim</option>
                </select>
              </div>

              <div className='form-group'>
                <label>Quer participar de atividade socioeducativa</label>
                <select name="want_participate_complementary_educational_activity" value={formData.want_participate_complementary_educational_activity ? "true" : "false"} onChange={handleSelectChange}>
                  <option value="false">Não</option>
                  <option value="true">Sim</option>
                </select>
              </div>

              <div className='form-group'>
                <label>Local do último ano letivo</label>
                <input type="text" name="location_last_school_year" value={formData.location_last_school_year || ''} onChange={handleInputChange} />
              </div>

              <div className='form-group'>
                <label>Suporte educacional especial</label>
                <input type="text" name="special_educational_support" value={formData.special_educational_support || ''} onChange={handleInputChange} />
              </div>

              <div className='form-group'>
                <label>
                  Considerações do interno
                  <TooltipInfo text="Registre observações relevantes feitas pelo interno." />
                </label>
                <textarea name="internal_considerations" value={formData.internal_considerations || ''} onChange={handleInputChange} />
              </div>

              <div className='form-group'>
                <label>
                  Síntese
                  <TooltipInfo text="Resumo breve do atendimento" />
                </label>
                <textarea name="synthesis" value={formData.synthesis || ''} onChange={handleInputChange} />
              </div>

              <div className="line">
                <div className="images-grid">
                  {/* Se já houver um arquivo, exibe o link para download */}
                  {receptionFileId && !formData.file ? (
                    <BinaryFileLink className="arquivo-incluso" resource={BINARY_RESOURCES.receptionEducational} id={receptionFileId} field="file">
                      <div style={{ width: 60, height: 60 }} className="image-thumbnail">
                        <img src={File} alt="Arquivo" />
                      </div>
                    </BinaryFileLink>
                  ) : null}

                  {/* Upload de um novo arquivo */}
                  <div className="form-cadastro-interno">
                    <div style={{ width: 200, height: 100 }} className="image-upload-container">
                      <input
                        type="file"
                        name="file"
                        accept=".pdf, .jpg, .jpeg, .png"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            setFormData((prev) => ({
                              ...prev,
                              file,
                            }));
                          }
                        }}
                        className="image-input"
                      />
                      <img src={File} alt="Upload icon" className="upload-icon" />
                    </div>
                  </div>
                </div>
              </div>

              <button type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Salvando...' : 'Salvar'}
              </button>
            </form>
          )}

          {currentTab === 'matricula' && (
            <div>
              <Titulo
                children={<h4 className='h4-title'>Histórico de Matrículas</h4>}
                children2={
                  <button className='adicionar' onClick={() => setIsEnrollmentModalOpen(true)}>
                    + Adicionar Matrícula
                  </button>
                }
              />
              <div>
                <ul className="timeline-list">
                  {enrollments.length > 0 ? (
                    enrollments.map((enroll) => {
                      const isFinished = !!enroll.end;
                      const turmaNome = enroll.class_education_name || 'Desconhecida';

                      return (
                        <li key={enroll.id} className="timeline-item">
                          <div className="timeline-date">
                            <strong>{new Date(enroll.start).toLocaleDateString()}</strong>
                            <button
                              type="button"
                              className="edit-icon-button"
                              onClick={() => {
                                setEditEnrollmentData(prepareEditEnrollmentData(enroll));
                                setIsEditEnrollmentModalOpen(true);
                              }}
                            >
                              <FontAwesomeIcon icon={faPen} />
                            </button>
                          </div>
                          <div className="timeline-content">
                            <p><strong>Turma:</strong> {turmaNome}</p>
                            <p><strong>Status:</strong> {isFinished ? 'Concluído' : 'Em andamento'}</p>
                            {isFinished && (
                              <p><strong>Fim:</strong> {new Date(enroll.end).toLocaleDateString()}</p>
                            )}
                          </div>
                        </li>
                      );
                    })
                  ) : (
                    <p className='semDados'>Nenhuma matrícula registrada.</p>
                  )}
                </ul>
              </div>
            </div>
          )}

          {currentTab === 'notas' && (
            <div className="notas-container">
              <Titulo
                children={<h4 className='h4-title'>Boletim</h4>}
                children2={
                  <button onClick={() => setIsScoreModalOpen(true)}>
                    + Adicionar Nota
                  </button>
                }
              />
              <table className="score-table">
                <thead>
                  <tr>
                    <th>Data</th>
                    <th>Disciplina</th>
                    <th>Tipo do teste</th>
                    <th>Nota</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {scores.length > 0 ? (
                    scores.map(score => (
                      <tr key={score.id}>
                        <td>{new Date(score.date).toLocaleDateString()}</td>
                        <td>{score.subject_name || '---'}</td>
                        <td>{score.type_test}</td>
                        <td>{score.score}</td>
                        <td>
                          <button
                            onClick={() => {
                              setScoreFormData({
                                id: score.id,
                                date: score.date.split('T')[0],
                                type_test: score.type_test,
                                student: score.student,
                                subject: score.subject,
                                score: score.score,
                              });
                              setIsScoreModalOpen(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faPen} />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className='semDados'>Nenhuma nota registrada.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

          {currentTab === 'frequencia' && (
            <div className="notas-container">
              <Titulo
                children={
                  <h4 className='h4-title'>Controle de Frequência</h4>

                }
                children2={
                  <button
                    onClick={() => {
                      setFrequencyFormData({
                        id: '',
                        date: localToday(),
                        presence: '',
                        faults: '',
                        student: formData.internal,
                        subject: ''
                      });
                      setIsFrequencyModalOpen(true);
                    }}
                  >
                    Adicionar Frequência
                  </button>

                }
              />

              <table className="score-table">
                <thead>
                  <tr>
                    <th>Disciplina</th>
                    <th>Presenças</th>
                    <th>Faltas</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {frequencies.length > 0 ? (
                    frequencies.map((freq) => (
                      <tr key={freq.id}>
                        <td>{freq.subject_name}</td>
                        <td>{freq.presence}</td>
                        <td>{freq.faults}</td>
                        <td>
                          <button
                            onClick={() => {
                              setFrequencyFormData(prepareFrequencyFormData(freq));
                              setIsFrequencyModalOpen(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faPen} />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className='semDados'>Nenhuma frequência registrada.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

          {currentTab === 'resultado' && (
            <div>
              <Titulo
                children={
                  <h4 className='h4-title'>Resultado Final</h4>
                }
                children2={
                  <button onClick={() => openFinalModal()}>+ Novo Resultado</button>
                }
              />

              <table>
                <thead>
                  <tr>
                    <th>Data</th>
                    <th>Disciplina</th>
                    <th>Status</th>
                    <th>Observação</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {finalResults.length ? finalResults.map(fr => (
                    <tr key={fr.id}>
                      <td>{new Date(fr.date).toLocaleDateString()}</td>
                      <td>{fr.subject_name}</td>
                      <td>{fr.approved}</td>
                      <td>{fr.observation}</td>
                      <td>
                        <button onClick={() => {
                          setFinalFormData(prepareFinalFormData(fr));
                          setIsFinalModalOpen(true);
                        }}>
                          <FontAwesomeIcon icon={faPen} />
                        </button>
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="5" className='semDados'>Nenhum resultado registrado.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

          {currentTab === 'alfabetizacao' && (
            <div>
              <Titulo
                children={<h4 className='h4-title'>Lista de Cursos IBRAEMA</h4>}
                children2={
                  <button onClick={() => setIsIbraemaModalOpen(true)} className="adicionar">
                    + Adicionar Novo
                  </button>
                }
              />
              <div className='content-table '>
                <table className="tabela">
                  <thead>
                    <tr>
                      <th>Início</th>
                      <th>Fim/Status</th>
                      <th>Carga</th>
                      <th>Curso</th>
                      <th>Monitor</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {literacies.length > 0
                      ? literacies.map(item => (
                        <tr key={item.id}>
                          <td>{item.start.split('T')[0]}</td>
                          <td>{item.end ? item.end.split('T')[0] : 'Em andamento'}</td>
                          <td>{item.workload}</td>
                          <td>{item.course}</td>
                          <td>{item.monitor_name}</td>
                          <td>
                            <button>
                              <FontAwesomeIcon
                                icon={faPen}
                                onClick={() => {
                                  setIbraemaFormData(prepareIbraemaFormData(item));
                                  setIsIbraemaModalOpen(true);
                                }}
                              />
                            </button>
                          </td>
                        </tr>
                      ))
                      : <tr><td colSpan="7" className="semDados">Nenhum registro encontrado.</td></tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {currentTab === 'leitura' && (
            <div>
              <Titulo
                children={<h4 className='h4-title'>Leitura Livre</h4>}
                children2={
                  <button onClick={() => setIsReadingModalOpen(true)}>
                    Adicionar
                  </button>
                }
              />
              <div className="timeline">
                <h4>Histórico de Leituras</h4>
                <ul className="timeline-list">
                  {freeReadings.map((reading) => (
                    <li key={reading.id} className="timeline-item">
                      <div className="timeline-date">
                        <strong>{new Date(reading.date).toLocaleDateString()}</strong>
                      </div>
                      <div className="timeline-content">
                        <p><strong>Livro:</strong> {books.find(b => b.id === reading.book)?.title || "Desconhecido"}</p>
                        <p><strong>Detalhes:</strong> {reading.detail}</p>
                        <p><strong>Observação:</strong> {reading.observation}</p>
                        <p><strong>Validado:</strong> {reading.validated ? "Sim" : "Não"}</p>
                        <p><strong>Remissão:</strong> {reading.remission ? "Sim" : "Não"}</p>
                        {/* Se houver um arquivo, exibe um link para download */}
                        {hasBinaryField(reading, 'resume') ? (
                          <p>
                            <strong>Resumo:</strong>{" "}
                            <BinaryFileLink resource={BINARY_RESOURCES.reading} id={reading.id} field="resume">
                              Visualizar Arquivo
                            </BinaryFileLink>
                          </p>
                        ) : (
                          <p><strong>Resumo:</strong> Nenhum arquivo enviado</p>
                        )}
                        {/* Exibe observação se houver */}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}

          {currentTab === 'evolucao' && (
            <div>
              <form onSubmit={handleSubmitEvolution}>
                <textarea
                  name="evolution"
                  value={formData.evolution}
                  onChange={handleInputChange}
                  required
                />
                <button type="submit" className="social-submit-button" disabled={isSubmitting}>
                  {isSubmitting ? 'Salvando...' : 'Adicionar Evolução'}
                </button>
              </form>
              <div className="timeline">
                <h4>Histórico de Evolução</h4>
                <ul className="timeline-list">
                  {evolutions.length > 0 ? (
                    evolutions.map((evo, index) => (
                      <li key={index} className="timeline-item">
                        <div className="timeline-date">
                          <strong>{new Date(evo.date).toLocaleString()}</strong>
                        </div>
                        <div className="timeline-content">
                          <p><strong>Detalhes:</strong> {evo.data}</p>
                        </div>
                      </li>
                    ))
                  ) : (
                    <p>Nenhuma evolução registrada.</p>
                  )}
                </ul>
              </div>
            </div>
          )}


        </div>
          </>
        )}
      </div>

      {/* Modal de edição de matrícula */}
      {isEditEnrollmentModalOpen && editEnrollmentData && (
        <Modal
          isOpen={isEditEnrollmentModalOpen}
          closeModal={closeEditEnrollmentModal}
          title="Editar Matrícula"
        >
          <form onSubmit={handleSubmitEditEnrollment}>
            <div className="form-group">
              <label>Data de Início</label>
              <input
                type="date"
                name="start"
                value={editEnrollmentData.start}
                onChange={(e) =>
                  setEditEnrollmentData((prev) => ({ ...prev, start: e.target.value }))
                }
              />
            </div>
            <div className="form-group">
              <label>Data de Fim (Conclusão)</label>
              <input
                type="date"
                name="end"
                value={editEnrollmentData.end || ''}
                onChange={(e) =>
                  setEditEnrollmentData((prev) => ({ ...prev, end: e.target.value }))
                }
              />
            </div>
            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Salvando...' : 'Salvar Alterações'}
            </button>
          </form>
        </Modal>
      )}

      {/* Modal de frequencia */}
      {isFrequencyModalOpen && (
        <Modal
          isOpen={isFrequencyModalOpen}
          closeModal={closeFrequencyModal}
          title="Registrar Frequência"
        >
          <form onSubmit={handleSubmitFrequency}>
            <div className="form-group">
              <label>Data</label>
              <input
                type="date"
                name="date"
                value={frequencyFormData.date}
                onChange={(e) => setFrequencyFormData({ ...frequencyFormData, date: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>Matrícula</label>
              <select
                name="student"
                value={frequencyFormData.student}
                onChange={e =>
                  setFrequencyFormData(prev => ({ ...prev, student: e.target.value }))
                }
                required
              >
                <option value="">Selecione curso</option>
                {enrollments.map(enroll => (
                  <option key={enroll.id} value={enroll.id}>
                    {enroll.class_education_name || 'Turma desconhecida'} –{' '}
                    {new Date(enroll.start).toLocaleDateString()}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Disciplina</label>
              <select
                name="subject"
                value={frequencyFormData.subject}
                onChange={(e) => setFrequencyFormData({ ...frequencyFormData, subject: e.target.value })}
              >
                <option value="">Selecione</option>
                {subjects.map(subject => (
                  <option key={subject.id} value={subject.id}>{subject.type_name}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Presenças</label>
              <input
                type="number"
                name="presence"
                value={frequencyFormData.presence}
                onChange={(e) => setFrequencyFormData({ ...frequencyFormData, presence: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>Faltas</label>
              <input
                type="number"
                name="faults"
                value={frequencyFormData.faults}
                onChange={(e) => setFrequencyFormData({ ...frequencyFormData, faults: e.target.value })}
              />
            </div>
            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Salvando...' : 'Salvar'}
            </button>
          </form>
        </Modal>
      )}

      {/*  Nodal de resultado final */}
      {isFinalModalOpen && (
        <Modal
          title={finalFormData.id ? 'Editar Resultado' : 'Novo Resultado'}
          isOpen
          closeModal={closeFinalResultModal}
        >
          <form onSubmit={handleSubmitFinal}>
            <div className="form-group">
              <label>Data</label>
              <input
                type="date"
                name="date"
                value={finalFormData.date}
                onChange={handleFinalChange}
              />
            </div>
            <div className="form-group">
              <label>Matrícula</label>
              <select
                name="student"
                value={finalFormData.student}
                onChange={handleFinalChange}
                required
              >
                <option value="">Selecione uma matrícula</option>
                {enrollments.map(enroll => (
                  <option key={enroll.id} value={enroll.id}>
                    {enroll.class_education_name || 'Turma desconhecida'} – {new Date(enroll.start).toLocaleDateString()}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Disciplina</label>
              <select
                name="subject"
                value={finalFormData.subject}
                onChange={handleFinalChange}
                required
              >
                <option value="">Selecione</option>
                {subjects.map(s => (
                  <option key={s.id} value={s.id}>{s.type_name}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Status</label>
              <input
                type="text"
                name="approved"
                value={finalFormData.approved}
                onChange={handleFinalChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Observação</label>
              <textarea
                name="observation"
                value={finalFormData.observation}
                onChange={handleFinalChange}
              />
            </div>
            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Salvando...' : 'Salvar'}
            </button>
          </form>
        </Modal>
      )}

      {/* Modal de matrícula */}
      <Modal
        isOpen={isEnrollmentModalOpen}
        closeModal={() => {
          setIsEnrollmentModalOpen(false);
          setEnrollmentFormData({
            class_education: '',
            start: localToday(),
            internal: formData.internal
          });
        }}
        title="Nova Matrícula"
      >
        <form onSubmit={handleSubmitEnrollment}>
          <div className="form-group">
            <label>Turma</label>
            <select name="class_education" value={enrollmentFormData.class_education} onChange={handleEnrollmentInputChange}>
              <option value="">Selecione uma turma</option>
              {classes.map((cls) => (
                <option key={cls.id} value={cls.id}>
                  {cls.name || 'Turma sem nome'}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Data de Início</label>
            <input
              type="date"
              name="start"
              value={enrollmentFormData.start}
              onChange={handleEnrollmentInputChange}
            />
          </div>
          <div className="form-group">
            <button type="submit" className='adicionar' disabled={isSubmitting}>
              {isSubmitting ? 'Salvando...' : 'Matricular interno'}
            </button>
          </div>
        </form>
      </Modal>

      {/* Modal de nota */}
      <Modal
        isOpen={isScoreModalOpen}
        closeModal={() => {
          setIsScoreModalOpen(false);
          setScoreFormData({
            date: localToday(),
            type_test: '',
            student: '',
            subject: '',
            score: '',
          });
        }}
        title="Registrar Nota"
      >
        <form onSubmit={handleSubmitScore}>
          <div className="form-group">
            <label>Data da Prova</label>
            <input type="date" name="date" value={scoreFormData.date} onChange={handleScoreInputChange} />
          </div>
          <div className="form-group">
            <label>Nota</label>
            <input type="number" step="0.1" name="score" value={scoreFormData.score} onChange={handleScoreInputChange} />
          </div>
          <div className="form-group">
            <label>Matrícula</label>
            <select
              name="student"
              value={scoreFormData.student}
              onChange={handleScoreInputChange}
              required
            >
              <option value="">Selecione uma matrícula</option>
              {enrollments.map(enroll => (
                <option key={enroll.id} value={enroll.id}>
                  {enroll.class_education_name || 'Turma desconhecida'} – {new Date(enroll.start).toLocaleDateString()}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Disciplina</label>
            <select name="subject" value={scoreFormData.subject} onChange={handleScoreInputChange}>
              <option value="">Selecione</option>
              {subjects.map(subject => (
                <option key={subject.id} value={subject.id}>{subject.type_name}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Tipo de teste</label>
            <select name="type_test" value={scoreFormData.type_test} onChange={handleScoreInputChange} required>
              <option value="">Selecione</option>
              <option value="Mensal">Mensal</option>
              <option value="Bimestral">Bimestral</option>
              <option value="Trimestral">Trimestral</option>
              <option value="Semestral">Semestral</option>
              <option value="Final">Final</option>
            </select>
          </div>
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Salvando...' : 'Salvar Nota'}
          </button>
        </form>
      </Modal>

      {/* Modal de leitura livre */}
      <Modal
        isOpen={isReadingModalOpen}
        closeModal={() => {
          setIsReadingModalOpen(false);
          setReadingFormData({
            id: '',
            date: localToday(),
            detail: '',
            resume: null,
            validated: false,
            observation: '',
            remission: false,
            book: '',
            internal: internalDetails?.id || '',
          });
          setBookQuery('');
          setShowBookResults(false);
        }}
        title="Nova Leitura Livre"
      >
        <form onSubmit={handleSubmitReading}>
          <div className='form-group'>
            <label>Data *</label>
            <input type="date" name="date" value={readingFormData.date} onChange={handleReadingInputChange} required />
          </div>
          <div className='form-group'>
            <label>Detalhes *</label>
            <textarea name="detail" value={readingFormData.detail} onChange={handleReadingInputChange} required />
          </div>
          <div className='form-group'>
            <label>Livro * <TooltipInfo text="Digite o título do livro para buscar." /></label>
            <div className="search-wrapper">
              <input
                type="text"
                value={bookQuery}
                onChange={(e) => {
                  setBookQuery(e.target.value.toUpperCase());
                  setShowBookResults(true);
                  setReadingFormData((prev) => ({ ...prev, book: '' }));
                }}
                onFocus={() => setShowBookResults(true)}
                onBlur={() => setTimeout(() => setShowBookResults(false), 150)}
                placeholder="Digite o título ou selecione um livro"
                autoComplete="off"
                required
              />
              {showBookResults && (
                <div className="social-search-results">
                  {isSearchingBooks ? (
                    <div className="social-search-result-item search-result-loading">Buscando...</div>
                  ) : bookResults.length > 0 ? (
                    bookResults.map((book) => (
                      <div
                        key={book.id}
                        className="social-search-result-item"
                        onMouseDown={() => handleSelectBook(book)}
                      >
                        {book.title}
                      </div>
                    ))
                  ) : (
                    <div className="social-search-result-item search-result-empty">Nenhum livro encontrado.</div>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className='form-group'>
            <label>Observação *</label>
            <textarea name="observation" value={readingFormData.observation} onChange={handleReadingInputChange} required />
          </div>
          <div className='form-group'>
            <h4>

            </h4>
            <label>Resumo (Se for para Remissão) <TooltipInfo text="Anexe o resumo da leitura (PDF, JPG ou PNG)." /></label>
            <input
              type="file"
              name="resume"
              accept=".pdf, .jpg, .jpeg, .png"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  setReadingFormData((prev) => ({
                    ...prev,
                    resume: file,
                  }));
                }
              }}
            />
          </div>
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Salvando...' : 'Salvar'}
          </button>
        </form>
      </Modal>

      {/* Modal ibraema */}
      <Modal
        isOpen={isIbraemaModalOpen}
        closeModal={closeIbraemaModal}
        title={ibraemaFormData.id ? 'Editar Ibraema' : 'Nova Ibraema'}
      >
        <div>
          <strong>Monitor:</strong>
          {ibraemaFormData.monitor_name
            ? <p>{ibraemaFormData.monitor_name}</p>
            : <p className='semDados'>Nenhum monitor selecionado.</p>
          }
        </div>

        <Titulo
          children={
            <SearchInternal
              onSelect={(internal) => {
                setIbraemaFormData(prev => ({
                  ...prev,
                  monitor: internal.id,
                  monitor_name: internal.name
                }));
              }}
            />
          }
        />

        <form onSubmit={handleSubmitIbraema}>
          <div className="form-group">
            <label>Data Início</label>
            <input
              type="date"
              name="start"
              value={ibraemaFormData.start}
              onChange={handleIbraemaChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Data Fim</label>
            <input
              type="date"
              name="end"
              value={ibraemaFormData.end}
              onChange={handleIbraemaChange}
            />
          </div>
          <div className="form-group">
            <label>Carga horária
              <TooltipInfo text="Carga horária que o aluno estudou." />
            </label>
            <div style={{ display: 'flex', gap: '10px' }}>
              <input
                type="number"
                name="workload_hours"
                value={ibraemaFormData.workload_hours || ''}
                onChange={e =>
                  setIbraemaFormData(prev => ({ ...prev, workload_hours: e.target.value }))
                }
                placeholder="Horas"
                min={0}
                required
              />
              <input
                type="number"
                name="workload_minutes"
                value={ibraemaFormData.workload_minutes || ''}
                onChange={e =>
                  setIbraemaFormData(prev => ({ ...prev, workload_minutes: e.target.value }))
                }
                placeholder="Minutos"
                min={0}
                max={59}
              />
            </div>
          </div>
          <div className="form-group">
            <label>Curso</label>
            <select
              name="course"
              value={ibraemaFormData.course}
              onChange={handleIbraemaChange}
              required
            >
              <option value="">
                {ibraemaFormData.id && ibraemaFormData.course
                  ? ibraemaFormData.course
                  : 'Selecione'}
              </option>
              {courses.map(course => (
                <option key={course.id} value={course.id}>
                  {course.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Matrícula</label>
            <select
              name="student"
              value={ibraemaFormData.student}
              onChange={handleIbraemaChange}
              required
            >
              <option value="">Selecione</option>
              {enrollments.map(e => (
                <option key={e.id} value={e.id}>
                  {e.class_education_name} – {new Date(e.start).toLocaleDateString()}
                </option>
              ))}
            </select>
          </div>
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Salvando...' : 'Salvar'}
          </button>
        </form>
      </Modal>
    </div >
  );
};

export default Education;
